import { Label } from "@/modern/components/ui/label";
import { cn } from "@/modern/utils";
import type { ReactNode } from "react";

interface EditorFormFieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
  children: ReactNode;
}

export function EditorFormField({ label, htmlFor, required, error, hint, className, children }: EditorFormFieldProps) {
  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={htmlFor} className="text-sm text-muted-foreground font-medium">
        {label}
        {required && " *"}
      </Label>
      {children}
      {error && <p className="text-sm text-destructive">{error}</p>}
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
